module.exports = __webpack_public_path__ + "img/want.1b4a416.png";